<div class="card-block" style="margin: 10px;">
    <div class="row">
        <div class="col-md-8">
            <span class="listHeaderText">Vault Payments ({{vaultPayListData?.length}})</span>
        </div>
        <div class="col-md-4 d-flex" style="justify-content: flex-end;">
            <div class="export" data-toggle="modal" data-target="#bookingModalRight"
                (click)="changeAddUpdateModalState(null,'Add')">
                <div class="add-actionbutton-icon">
                    <img src="{{ addIcon }}" aria-hidden="true">
                </div>
                <div class="add-actionbutton-text ">Add</div>
            </div>
            &nbsp; &nbsp;
            <export [showIconOnly]="false" [data]="selectedExportData"></export>
        </div>

        <div class="main-field">
            <div class="main-block-content">
                <div style="height: 500px; margin: 10px;">
                    <app-common-table [columnDefs]="columnDefs" [data]="vaultPayListData" [enableRowStyles]="false"
                        (commonDropdownChange)="onCommonTableDropdownChange($event)"
                        (selectedRowsChange)="onSelectedRowsChange($event)">
                    </app-common-table>
                </div>
            </div>
        </div>
    </div>
</div>